import React from 'react';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import { useIntl } from 'react-intl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { connect } from 'react-redux';

import css from './AboutUsPage.module.css';

import classNames from 'classnames';
import SectionHero from './SectionHero/SectionHero';
import SectionCreators from './SectionCreators/SectionCreators';
import SectionWhyMarketplaceExists from './SectionWhyMarketplaceExists/SectionWhyMarketplaceExists';
import { useConfiguration } from '../../context/configurationContext';

const AboutUsPageComponent = props => {
  const { scrollingDisabled } = props;

  const config = useConfiguration();
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'AboutUsPage.title' }) + ' | ' + config.marketplaceName;
  const desc = intl.formatMessage({ id: 'AboutUsPage.desc' });

  return (
    <Page
      title={title}
      description={desc}
      scrollingDisabled={scrollingDisabled}
      openGraphType="website"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: title,
      }}
    >
      <LayoutSingleColumn
        topbar={
          <>
            <TopbarContainer currentPage="HowItWorksPage" />
          </>
        }
        footer={<FooterContainer />}
      >
        <SectionHero intl={intl} className={classNames(css.section, css.sectionGrey)} />
        <hr className={css.divider} />
        <SectionCreators intl={intl} className={classNames(css.section, css.sectionWhite)} />
        <hr className={css.divider} />
        <SectionWhyMarketplaceExists
          intl={intl}
          className={classNames(css.section, css.sectionGrey)}
        />
        <hr className={css.divider} />
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const AboutUsPage = compose(
  withRouter,
  connect(mapStateToProps)
)(AboutUsPageComponent);

export default AboutUsPage;
